export default __webpack_public_path__ + "static/media/NIAS0480.34I-43128_-25789_0.89585444.jpg";